import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import Cookies from 'js-cookie';
import { Post } from 'Xhr/Xhr';

export const GetPatientForVizit = async (
  data,
  setPatientList
) => {



 
  const IdPerson =
    Cookies.get('user') &&
    JSON.parse(Cookies.get('user'))?.IdPerson;

  setPatientList('loading');

  // console.log(
  //   '------------------------------------------------------>',
  //   {
  //     TypeListId: data.inputFilter,
  //     idDoctor: IdPerson,
  //     beginDate: data.range.FromDate,
  //     EndDate: data.range.ToDate,
  //     topRecord: 100,
  //   }
  // );

  // console.log('--------------->', {
  //   TypeListId: data.inputFilter,
  //   idDoctor: IdPerson,
  //   beginDate: data.range.FromDate,
  //   EndDate: data.range.ToDate,
  //   topRecord: 100,
  //   clause: data.searchClause,
  // });




  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_GET_PATIENTS_FOR_VISIT}`,
    true,
    {
      TypeListId: data.inputFilter,
      idDoctor: IdPerson,
      beginDate: data.range.FromDate,
      EndDate: data.range.ToDate,
      topRecord: 100,
      clause: data.searchClause,
    }
  ).then((response) => {
    // console.log('response is =>', response);
    if (response.data.resCode === 1) {
      setPatientList(
        response.data.Data.lst || response.data.Data
      );
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
